import React, { useState } from "react";
import { UserCog, User, UserPlus, Check } from "lucide-react";
import { isPreview, switchToPinned, switchToFreshGuest } from "../pinSession";
import { getStoredUser } from "../lib/api";

// Preview-only floating menu to flip between the pinned account "1" and a fresh guest.
const DevAccountSwitcher = () => {
  const [open, setOpen] = useState(false);
  if (!isPreview) return null;
  const pinned = !localStorage.getItem("fc_dev_unpin");
  const name = getStoredUser()?.username || "…";

  return (
    <div className="fixed bottom-4 left-4 z-[60]" data-testid="dev-account-switcher">
      {open && (
        <div className="mb-2 w-56 rounded-xl border border-white/15 bg-[#1E293B]/95 backdrop-blur-md p-2 shadow-2xl text-white">
          <div className="px-2 pt-1 pb-2 text-[10px] font-bold uppercase tracking-wide text-[#38BDF8]">Preview accounts</div>
          <div className="px-2 pb-2 text-xs text-slate-400" data-testid="dev-current-user">
            Signed in as <span className="text-white font-semibold">{name}</span>
          </div>
          {[
            { k: "pinned", label: 'Account "1"', Icon: User, on: pinned, go: switchToPinned },
            { k: "guest", label: "Signed out (new visitor)", Icon: UserPlus, on: !pinned, go: switchToFreshGuest },
          ].map(({ k, label, Icon, on, go }) => (
            <button
              key={k}
              data-testid={`dev-switch-${k}`}
              onClick={go}
              className="w-full flex items-center gap-2 rounded-lg px-2 py-2 text-sm hover:bg-white/10 transition-colors"
            >
              <Icon className="w-4 h-4 text-[#10B981]" />
              <span className="flex-1 text-left">{label}</span>
              {on && <Check className="w-4 h-4 text-[#10B981]" />}
            </button>
          ))}
          <div className="px-2 pt-1 text-[10px] text-slate-500">Signed out shows the site as a brand-new visitor.</div>
        </div>
      )}
      <button
        data-testid="dev-switcher-toggle"
        onClick={() => setOpen((v) => !v)}
        aria-label="Switch preview account"
        className="w-10 h-10 rounded-full bg-[#1E293B] border border-[#38BDF8]/40 text-[#38BDF8] flex items-center justify-center shadow-lg hover:scale-105 transition-transform"
      >
        <UserCog className="w-5 h-5" />
      </button>
    </div>
  );
};

export default DevAccountSwitcher;
